import {
  Avatar,
  Box,
  Flex,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useReviews } from "api/reviews";
import { format } from "date-fns";
import PageTitle from "generics/PageTitle";
import ToolbarPortal from "generics/ToolbarPortal";
import React from "react";
import StarRatings from "react-star-ratings";

export default function Reviews() {
  const reviewsQuery = useReviews();
  return (
    <Box px="12" py="6">
      <ToolbarPortal>
        <Flex justifyContent="space-between" alignItems="center">
          <PageTitle flexGrow={1}>Reviews</PageTitle>
        </Flex>
      </ToolbarPortal>
      <Table>
        <Thead>
          <Tr>
            <Th w="20%">User</Th>
            <Th w="20%">Date</Th>
            <Th w="20%">Rating</Th>
            <Th>Review</Th>
          </Tr>
        </Thead>
        <Tbody>
          {reviewsQuery.isLoading ? (
            <Tr>
              <Td colSpan={6}>
                <Text textAlign="center" color="gray.500">
                  <Spinner />
                </Text>
              </Td>
            </Tr>
          ) : reviewsQuery.data?.length === 0 ? (
            <Tr>
              <Td colSpan={6}>
                <Text textAlign="center" color="gray.500">
                  No Reviews!
                </Text>
              </Td>
            </Tr>
          ) : (
            reviewsQuery.data?.map((review: any) => {
              return (
                <Tr fontSize="sm" key={review.id}>
                  <Td>
                    <Stack direction="row" alignItems="center" spacing={3}>
                      <Avatar
                        name={review.anonymous ? "Anonymous" : review?.user?.name}
                        src={
                          review.anonymous ? "Anonymous" : review?.user?.photoUrl
                        }
                        size="sm"
                      />

                      <Box>
                        <Text fontWeight="bold">
                          {review.anonymous ? "Anonymous" : review?.user?.name}
                        </Text>
                      </Box>
                    </Stack>
                  </Td>
                  <Td>
                    <Text>
                      {format(review.lastUpdated, "yyyy-MM-dd, hh:mm a")}
                    </Text>
                  </Td>
                  <Td>
                    <StarRatings
                      rating={review.rating}
                      starRatedColor="gold"
                      numberOfStars={5}
                      name="rating"
                      starDimension="18px"
                      starSpacing="2px"
                    />
                  </Td>
                  <Td>
                    <Text>{review.comment}</Text>
                  </Td>
                </Tr>
              );
            })
          )}
        </Tbody>
      </Table>
    </Box>
  );
}
